import React from 'react';

import { Card, CardContent, Typography } from '@material-ui/core';

import { ReactComponent as ExpandIcon } from './assets/expand-icon.svg';
import styles from './styles.module.scss';

function StudentPreview({ name, workImageUrl }) {
  return (
    <Card className={styles.studentPreview}>
      <CardContent className={styles.studentPreviewContent}>
        <div className={styles.studentPreviewName}>
          <Typography variant="H-TEXT-1">{name}</Typography>

          <ExpandIcon className={styles.studentPreviewExpandBtn} />
        </div>

        <div className={styles.studentPreviewImageContainer}>
          <img
            src={workImageUrl}
            alt={`${name}'s work`}
            className={styles.studentPreviewImage}
          />
        </div>
      </CardContent>
    </Card>
  );
}

export default StudentPreview;
